import type { TOC } from '@ember/component/template-only';
import { Illustration } from 'frontend-utils';

interface HotelBenchmarkInsightCompetitorsSmartCompsetSmartCompsetBuilderSmartCompsetBuilderInfoSignature {
  Args: {
    imageHtml: string;
    subTitle: string;
    title: string;
  };
}

const HotelBenchmarkInsightCompetitorsSmartCompsetSmartCompsetBuilderSmartCompsetBuilderInfo =
  <template>
    <div class="smart-compset__builder__body__left__info">
      <p class="heading-1">
        {{@title}}
      </p>

      <p class="text-300--regular">
        {{@subTitle}}
      </p>

      <div class="smart-compset__builder__body__left__info__illustration">
        <Illustration @html={{@imageHtml}} />
      </div>
    </div>
  </template> satisfies TOC<HotelBenchmarkInsightCompetitorsSmartCompsetSmartCompsetBuilderSmartCompsetBuilderInfoSignature>;

export default HotelBenchmarkInsightCompetitorsSmartCompsetSmartCompsetBuilderSmartCompsetBuilderInfo;
